module.exports = __webpack_public_path__ + "img/home_kmtx.70e357a9.png";